/* Swipe & Build game (mobile). See sections/dw-swipe-match.liquid. */
(() => {
  const money = (cents) =>
    '₹' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: cents % 100 ? 2 : 0 });
  const esc = (s) =>
    String(s || '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  const shuffle = (a) => {
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  };
  const withWidth = (src, w) => (src ? src + (src.includes('?') ? '&' : '?') + 'width=' + w : '');

  async function loadProducts(root, limit) {
    // A page can hand over its own product list (e.g. the Christmas page) instead of collections.
    const inline = root.querySelector('script[data-products]');
    if (inline) {
      try { return shuffle(JSON.parse(inline.textContent).filter((p) => p && p.id && p.image)); } catch (e) {}
    }
    const per = limit || parseInt(root.dataset.perCollection || '100', 10);
    const sources = (root.dataset.sources || '')
      .split(';')
      .filter(Boolean)
      .map((s) => s.split('|'));
    const seen = new Set();
    const all = [];
    await Promise.all(
      sources.map(async ([handle, label]) => {
        try {
          const res = await fetch(`/collections/${encodeURIComponent(handle)}/products.json?limit=${Math.min(per, 250)}`);
          const data = await res.json();
          (data.products || []).forEach((p) => {
            const v = (p.variants || []).find((x) => x.available);
            if (!v || seen.has(p.id) || !p.images || !p.images.length) return;
            seen.add(p.id);
            all.push({
              id: v.id,
              handle: p.handle,
              title: p.title,
              price: Math.round(parseFloat(v.price) * 100),
              compare: v.compare_at_price ? Math.round(parseFloat(v.compare_at_price) * 100) : 0,
              image: withWidth(p.images[0].src, 600),
              thumb: withWidth(p.images[0].src, 160),
              url: `/products/${p.handle}`,
              tag: label,
            });
          });
        } catch (e) {}
      })
    );
    return shuffle(all);
  }

  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';

    const stage = root.querySelector('[data-stage]');
    const loading = root.querySelector('[data-loading]');
    const done = root.querySelector('[data-done]');
    const countEl = root.querySelector('[data-wish-count]');
    let deck = [];
    let pool = [];
    let busy = false;

    const wl = () => window.DawbuWishlist;
    const updateCount = () => (countEl.textContent = wl() ? wl().items().length : 0);
    document.addEventListener('dw:wishlist-change', updateCount);

    function cardHtml(p) {
      const sale = p.compare > p.price ? `<s>${money(p.compare)}</s>` : '';
      return `
        <div class="dw-swipe__card-img"><img src="${esc(p.image)}" alt="${esc(p.title)}" draggable="false"></div>
        <span class="dw-swipe__stamp dw-swipe__stamp--like">LOVE IT</span>
        <span class="dw-swipe__stamp dw-swipe__stamp--nope">PASS</span>
        <div class="dw-swipe__card-info">
          <span class="dw-swipe__tag">${esc(p.tag)}</span>
          <p class="dw-swipe__name">${esc(p.title)}</p>
          <p class="dw-swipe__price">${money(p.price)} ${sale}</p>
        </div>`;
    }

    function renderStack() {
      stage.querySelectorAll('.dw-swipe__card').forEach((c) => c.remove());
      done.hidden = deck.length > 0;
      deck.slice(0, 3).reverse().forEach((p, i, arr) => {
        const depth = arr.length - 1 - i; // 0 = top card
        const el = document.createElement('div');
        el.className = 'dw-swipe__card';
        el.style.setProperty('--depth', depth);
        el.innerHTML = cardHtml(p);
        if (depth === 0) bindDrag(el);
        stage.appendChild(el);
      });
      // warm the next few images
      deck.slice(3, 6).forEach((p) => (new Image().src = p.image));
    }

    function decide(liked, el) {
      if (busy || !deck.length) return;
      busy = true;
      const p = deck[0];
      const card = el || stage.querySelector('.dw-swipe__card:last-child');
      if (liked && wl()) wl().add({ id: p.id, handle: p.handle, title: p.title, price: p.price, image: p.thumb, url: p.url });
      if (card) {
        card.classList.add(liked ? 'is-liked' : 'is-noped');
        card.style.transition = 'transform .35s ease, opacity .35s ease';
        card.style.transform = `translate(${liked ? 140 : -140}%, -4%) rotate(${liked ? 22 : -22}deg)`;
        card.style.opacity = '0';
      }
      setTimeout(() => {
        deck.shift();
        renderStack();
        busy = false;
      }, card ? 300 : 0);
    }

    function bindDrag(card) {
      let x0 = 0, y0 = 0, dx = 0, dy = 0, dragging = false, horizontal = null;
      const likeStamp = card.querySelector('.dw-swipe__stamp--like');
      const nopeStamp = card.querySelector('.dw-swipe__stamp--nope');

      card.addEventListener('pointerdown', (e) => {
        if (busy) return;
        dragging = true;
        horizontal = null;
        x0 = e.clientX;
        y0 = e.clientY;
        dx = dy = 0;
        card.style.transition = 'none';
      });
      card.addEventListener('pointermove', (e) => {
        if (!dragging) return;
        dx = e.clientX - x0;
        dy = e.clientY - y0;
        if (horizontal === null && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) {
          horizontal = Math.abs(dx) > Math.abs(dy);
          if (horizontal) card.setPointerCapture(e.pointerId);
          else return (dragging = false); // let the page scroll
        }
        if (!horizontal) return;
        card.style.transform = `translate(${dx}px, ${dy * 0.15}px) rotate(${dx / 18}deg)`;
        const k = Math.min(1, Math.abs(dx) / 90);
        likeStamp.style.opacity = dx > 0 ? k : 0;
        nopeStamp.style.opacity = dx < 0 ? k : 0;
      });
      const end = () => {
        if (!dragging) return;
        dragging = false;
        if (horizontal && Math.abs(dx) > Math.min(100, card.offsetWidth * 0.28)) return decide(dx > 0, card);
        card.style.transition = 'transform .25s ease';
        card.style.transform = '';
        likeStamp.style.opacity = nopeStamp.style.opacity = 0;
      };
      card.addEventListener('pointerup', end);
      card.addEventListener('pointercancel', end);
    }

  // Tracking: DOM events the tracker (mz-tracking.js EVMAP) turns into beacons; no-op without it.
  const track = (name, detail) => { try { if (window.mzEmit) window.mzEmit('swipe:' + name, detail || {}); } catch (e) {} };
    function start() {
      track('start', { count: pool.length });
      const have = new Set(wl() ? wl().items().map((i) => String(i.id)) : []);
      deck = shuffle(pool.filter((p) => !have.has(String(p.id))));
      if (!deck.length) deck = shuffle(pool.slice());
      renderStack();
    }

    root.querySelector('[data-like]').addEventListener('click', () => { track('like', { from: 'button' }); decide(true); });
    root.querySelector('[data-nope]').addEventListener('click', () => { track('skip', { from: 'button' }); decide(false); });
    root.querySelectorAll('[data-open-wishlist]').forEach((b) => b.addEventListener('click', () => { track('wishlist-open', {}); wl() && wl().open(); }));
    root.querySelector('[data-restart]').addEventListener('click', () => {
      track('restart', {});
      deck = shuffle(pool.slice());
      renderStack();
    });

    updateCount();
    // Fast start: a small first batch (8 per collection) gets cards on screen quickly; the full
    // list then loads in the background and is shuffled in behind the cards already showing.
    const full = parseInt(root.dataset.perCollection || '100', 10);
    const quick = !root.querySelector('script[data-products]') && full > 8;
    if (quick) {
      loadProducts(root, full).then((items) => {
        if (!items.length) return;
        const known = new Set(pool.map((p) => String(p.id)));
        const extra = items.filter((p) => !known.has(String(p.id)));
        const wasEmpty = !pool.length;
        pool = pool.concat(extra);
        if (wasEmpty) { loading.hidden = true; start(); return; }
        const have = new Set(wl() ? wl().items().map((i) => String(i.id)) : []);
        deck = deck.concat(extra.filter((p) => !have.has(String(p.id))));
        done.hidden = deck.length > 0;
      });
    }
    loadProducts(root, quick ? 8 : 0).then((items) => {
      if (pool.length) return; // the full list won the race
      pool = items;
      loading.hidden = true;
      if (!pool.length) {
        loading.hidden = false;
        loading.textContent = 'No toys to swipe right now — check back soon!';
        return;
      }
      start();
    });
  }

  function boot() {
    document.querySelectorAll('.dw-swipe').forEach((root) => {
      if (window.matchMedia('(min-width: 990px)').matches && !root.classList.contains('dw-pol-game')) return; // mobile only (the collection page game also plays on desktop)
      // Start well before the game scrolls into view, or shortly after the page has loaded,
      // whichever comes first, so the cards are ready by the time it is on screen.
      if (root.dataset.dwBooted) return;
      root.dataset.dwBooted = '1';
      let started = false;
      const go = () => { if (started) return; started = true; init(root); };
      if (!('IntersectionObserver' in window)) return go();
      const io = new IntersectionObserver(
        (entries) => {
          if (entries.some((e) => e.isIntersecting)) {
            io.disconnect();
            go();
          }
        },
        { rootMargin: '2000px 0px' }
      );
      io.observe(root);
      const soon = () => setTimeout(go, 1200);
      if (document.readyState === 'complete') soon();
      else window.addEventListener('load', soon, { once: true });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
